import React, { useContext } from "react";
import { CartContext } from "../Component/CartContext";
import productData from "../Datas/productData";
import "../css/cartpage.scss";
import { Link, useNavigate } from "react-router-dom";
import { FiTrash2 } from "react-icons/fi";
import { BsCheck2 } from "react-icons/bs";

const CartPage = () => {
  const navigate = useNavigate();
  const { cartItems, removeFromCart, updateQuantity } = useContext(CartContext);

  const getProductById = (id) => {
    return productData.find((product) => product.id === id);
  };

  const calculateTotal = () => {
    let total = 0;
    cartItems.forEach((item) => {
      const product = getProductById(item.id);
      if (product) {
        const price = parseFloat(product.price.replace(/,/g, ""));
        total += price * item.quantity;
      }
    });
    return total;
  };

  const subtotal = calculateTotal(); 
  const shipping = 9.99;
  const total = subtotal + shipping;

  const totalItems = cartItems.reduce((acc, item) => acc + item.quantity, 0);

  const handleUpdateQuantity = (id, size, color, newQuantity) => {
    if (newQuantity > 0) {
      updateQuantity(id, size, color, newQuantity);
    }
  };

  const handleCheckout = () => {
    if (cartItems.length > 0) {
      navigate("/checkout");
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    } else {
      alert("Your cart is empty");
    }
  };

  const toTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  if (cartItems.length === 0) {
    return (
      <div className="cart-page empty">
        <h2>BAG</h2>
        <div className="cart-page__empty-content">
          <p>Your bag is empty.</p>
          <Link onClick={toTop} to="/shop">
            Continue Shopping
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="cart-page-container">
      <h1 className="cart-title">BAG</h1>
      
      <div className="cart-content">
        <div className="cart-items">
          {cartItems.map((item, index) => {
            const product = getProductById(item.id);
            if (!product) return null;

            return (
              <div key={index} className="cart-item">
                <div className="cart-item__image">
                  <img src={product.image} alt={product.name} />
                </div>
                
                <div className="cart-item__details">
                  <div className="cart-item__header">
                    <div className="cart-item__info-top">
                      <h3>{product.name.toUpperCase()}</h3>
                      <p className="price">${product.price}</p>
                    </div>
                  </div>
                  
                  <div className="cart-item__variants">
                    <p>Colour: {item.color}</p>
                    <p>Size: {item.size}</p>
                  </div>
                  
                  <div className="cart-item__actions">
                    <div className="quantity-selector">
                      <button onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity - 1)}>-</button>
                      <span>{item.quantity}</span>
                      <button onClick={() => handleUpdateQuantity(item.id, item.size, item.color, item.quantity + 1)}>+</button>
                    </div>
                    <button 
                      className="remove-btn" 
                      onClick={() => removeFromCart(item.id, item.size, item.color)}
                    >
                      <FiTrash2 />
                    </button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className="cart-summary">
          <p className="login-promo">
            <Link to="/login" className="underline">Log in</Link> for member deals and faster shopping
          </p>
          
          <div className="summary-details">
            <div className="summary-row">
              <span>Subtotal ({totalItems} item{totalItems > 1 ? 's' : ''})</span>
              <span>${subtotal.toFixed(2)}</span>
            </div>
            <div className="summary-row">
              <span>Estimated delivery</span>
              <span>${shipping.toFixed(2)}</span>
            </div>
            <div className="summary-row total">
              <span>Total</span>
              <span>${total.toFixed(2)} USD</span>
            </div>
          </div>
          
          <div className="discount-code">
            <span>+ Discount Code</span>
          </div>
          
          <button className="checkout-btn" onClick={handleCheckout}>
            Check out
          </button>
          
          <div className="summary-perks">
            <p><BsCheck2 /> 100 days of return</p>
            <p><BsCheck2 /> Buy now, pay later</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartPage;
